/**
 * Animated Spiral Favicon - Canvas-based frame animation
 * Works in all modern browsers (Chrome, Firefox, Safari, Edge)
 * Uses setInterval instead of RAF for reliable favicon tab updates
 */

let intervalId = null;
let angle = 0;

function drawSpiral(ctx, size, rotation) {
  ctx.clearRect(0, 0, size, size);

  // Dark background - matches site theme
  ctx.fillStyle = '#0A0A14';
  ctx.beginPath();
  ctx.roundRect(0, 0, size, size, 4);
  ctx.fill();

  const cx = size / 2;
  const cy = size / 2;

  ctx.save();
  ctx.translate(cx, cy);
  ctx.rotate(rotation);

  // Outer glow ring
  const outerGlow = ctx.createRadialGradient(0, 0, size * 0.28, 0, 0, size * 0.44);
  outerGlow.addColorStop(0, 'rgba(139, 92, 246, 0.15)');
  outerGlow.addColorStop(1, 'rgba(139, 92, 246, 0)');
  ctx.fillStyle = outerGlow;
  ctx.beginPath();
  ctx.arc(0, 0, size * 0.44, 0, Math.PI * 2);
  ctx.fill();

  // Draw thick spiral arms (3 arms for better visibility)
  const arms = 3;
  const maxRadius = size * 0.40;
  const turns = 3;
  const points = 80;

  for (let arm = 0; arm < arms; arm++) {
    const armOffset = (arm * Math.PI * 2) / arms;

    // Spiral path
    ctx.beginPath();
    for (let i = 2; i < points; i++) {
      const t = i / points;
      const theta = t * Math.PI * 2 * turns + armOffset;
      const r = t * maxRadius;
      const x = Math.cos(theta) * r;
      const y = Math.sin(theta) * r;
      if (i === 2) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }

    // Color per arm for depth effect
    const colors = ['#A855F7', '#8B5CF6', '#C084FC'];
    ctx.strokeStyle = colors[arm];
    ctx.lineWidth = Math.max(2, size * 0.09);
    ctx.lineCap = 'round';
    ctx.globalAlpha = arm === 0 ? 1 : 0.7;
    ctx.stroke();
  }

  ctx.globalAlpha = 1;

  // Bright center glow
  const glowGrad = ctx.createRadialGradient(0, 0, 0, 0, 0, size * 0.15);
  glowGrad.addColorStop(0, 'rgba(233, 213, 255, 0.9)');
  glowGrad.addColorStop(0.4, 'rgba(168, 85, 247, 0.5)');
  glowGrad.addColorStop(1, 'rgba(139, 92, 246, 0)');
  ctx.fillStyle = glowGrad;
  ctx.beginPath();
  ctx.arc(0, 0, size * 0.15, 0, Math.PI * 2);
  ctx.fill();

  ctx.restore();
}

export function startAnimatedFavicon() {
  // Stop any existing animation
  stopAnimatedFavicon();

  const canvas = document.createElement('canvas');
  canvas.width = 32;
  canvas.height = 32;
  const ctx = canvas.getContext('2d');

  // Remove old favicon links and create fresh one
  const oldLinks = document.querySelectorAll("link[rel*='icon']");
  oldLinks.forEach(l => l.remove());

  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  document.head.appendChild(link);

  // Use setInterval at ~15fps for reliable favicon updates
  // (requestAnimationFrame can be throttled for background tabs)
  intervalId = setInterval(() => {
    angle += 0.08;
    drawSpiral(ctx, 32, angle);
    try {
      link.href = canvas.toDataURL('image/png');
    } catch (e) {
      // Silently handle any toDataURL errors
    }
  }, 67); // ~15fps - enough for smooth favicon rotation
}

export function stopAnimatedFavicon() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
